import React from 'react'
import { useNetworkingBrief } from '../NetworkingBriefProvider'
import { EditorHeading } from '../../ResumeBuilder/Editor/common'
import { EditorItemTextField, EditorItemProvider } from './EditorItemProvider'
import { useTranslation } from '~/hooks/useTranslation'

const CallToActionEditor = () => {
  const { networkingBriefDocument: { callToAction } = {} } =
    useNetworkingBrief()
  const { t } = useTranslation('CallToActionEditor')

  return (
    <EditorItemProvider sectionName="callToAction" item={callToAction}>
      <div>
        <EditorHeading>{t('call_to_action')}</EditorHeading>
        <p>{t('call_to_action_desc')}</p>
        <div className="grid grid-cols-1 gap-x-6 gap-y-4 md:grid-cols-2">
          <EditorItemTextField
            containerClassName="md:col-span-2"
            fieldName="callToActionStatement"
            label={t('call_to_action_label')}
            areaClassName="h-[150px]"
          />
        </div>
      </div>
    </EditorItemProvider>
  )
}
export default CallToActionEditor
